import { catchError } from "../../catchErrors";
import { initLastOffersViewedComp } from "../../components/lastOffersViewed";
import { hideOffersListLoader, showOffersListLoader } from "../../components/loader";
import { createURL, generateURL } from "./offers";
import { ACTUAL_FILTER, CALL_GET_OFFERS, CURRENT_REQUESTS } from "./settings";

export const LS_KEY_CANDIDATURES = "userCandidatures";
export const LS_KEY_CANDIDATURES_LOAD_TIME = "userCandidaturesLoadTime"; // Saved in seconds

$(() => {
  // Remove search
  $(document).on("click", "#removeSearch", (event) => {
    ACTUAL_FILTER.search = "";
    ACTUAL_FILTER.autoCompletedSearch = "";

    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove province
  $(document).on("click", ".psf-offers__chips-list [remove-province]", (event) => {
      ACTUAL_FILTER.selectedProvince = "";
      ACTUAL_FILTER.selectedTowns = [];

      const target = event.currentTarget;
      const badge = target.parentElement;
      badge.remove();

      const towns = $(".psf-offers__chips-list [remove-town]").each((index, element) => {
        const targetTown = element;
        const badgeTown = targetTown.parentElement!;
        badgeTown.remove();
      })

      generateURL();
    }
  );

  // Remove town
  $(document).on("click", ".psf-offers__chips-list [remove-town]", (event) => {
    const removedTown: string = $(event.currentTarget).data("town");
    ACTUAL_FILTER.selectedTowns = ACTUAL_FILTER.selectedTowns.filter(
      (town) => town.toUpperCase() !== removedTown.toUpperCase()
    );

    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove min publication time
  $(document).on("click", "#removeMinPublicationDate", (event) => {
    ACTUAL_FILTER.minPublicationDate = null;
    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove working day type
  $(document).on("click", "#removeWorkingDayType", (event) => {
    ACTUAL_FILTER.workingDayType = null;
    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove IsInexperienced
  $(document).on("click", "#removeIsInexperienced", (event) => {
    ACTUAL_FILTER.isInexperienced = null;
    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove IsUntrained
  $(document).on("click", "#removeIsUntrained", (event) => {
    ACTUAL_FILTER.isUntrained = null;
    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove IsVehicleNeeded
  $(document).on("click", "#removeIsVehicleNeeded", (event) => {
    ACTUAL_FILTER.isVehicleNeeded = null;
    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove IsTeleworking
  $(document).on("click", "#removeIsTeleworking", (event) => {
    ACTUAL_FILTER.isTeleworking = null;
    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove offer type
  $(document).on("click", "#removeType", (event) => {
    ACTUAL_FILTER.type = null;
    const target = event.currentTarget;
    const badge = target.parentElement;
    badge.remove();

    generateURL();
  });

  // Remove all filters
  $(document).on("click", "#removeFilters", (event) => {
    ACTUAL_FILTER.search = "";
    ACTUAL_FILTER.autoCompletedSearch = "";
    ACTUAL_FILTER.selectedProvince = "";
    ACTUAL_FILTER.selectedTowns = [];
    ACTUAL_FILTER.minPublicationDate = null;
    ACTUAL_FILTER.workingDayType = null;
    ACTUAL_FILTER.isInexperienced = null;
    ACTUAL_FILTER.isUntrained = null;
    ACTUAL_FILTER.isVehicleNeeded = null;
    ACTUAL_FILTER.isTeleworking = null;
    ACTUAL_FILTER.type = null;

    $(".psf-offers__chips--primary .psf-offers__chips-list ").empty();
    $(".psf-offers__chips--secondary .psf-offers__chips-list ").empty();
    $(".psf-offers__chips--remove-filters").remove();

    generateURL();
  });

  $(document).on("click", ".psf-offers__filters-remove-filters", (event) => {
    ACTUAL_FILTER.search = "";
    ACTUAL_FILTER.autoCompletedSearch = "";
    ACTUAL_FILTER.selectedProvince = "";
    ACTUAL_FILTER.selectedTowns = [];
    ACTUAL_FILTER.minPublicationDate = null;
    ACTUAL_FILTER.workingDayType = null;
    ACTUAL_FILTER.isInexperienced = null;
    ACTUAL_FILTER.isUntrained = null;
    ACTUAL_FILTER.isVehicleNeeded = null;
    ACTUAL_FILTER.isTeleworking = null;
    ACTUAL_FILTER.type = null;

    $(".psf-offers__chips--primary .psf-offers__chips-list ").empty();
    $(".psf-offers__chips--secondary .psf-offers__chips-list ").empty();
    $(".psf-offers__chips--remove-filters").remove();

    generateURL();
  });

  // Offer Click
  $(document).on(
    "click",
    "#offers-list article[psf-offer]:not(.psf-last-offers)",
    (event) => {
      window.dataLayer?.push({
        event: "Ver_oferta_",
      });
    }
  );

  // Pagination
  $(document).on(
    "click",
    "#paginationNumbers .eui-table-pagination-btn:not('.eui-table-pagination-btn--active')",
    function (event) {
      showOffersListLoader();
      event.preventDefault();
      const page = $(this).data("page");
      CURRENT_REQUESTS.requestsNumber += 1;
      const currentRequest = CURRENT_REQUESTS.requestsNumber;
      let generatedURL = createURL();
      $.post({
        url: CALL_GET_OFFERS,
        data: { 
          page: page, 
          filterViewModel: ACTUAL_FILTER,
          generatedURL
        },
      })
        .done((data) => {
          const hasNewRequest: boolean = currentRequest < CURRENT_REQUESTS.requestsNumber;
          if(!hasNewRequest) {
            $("#offers-list").replaceWith(data).show("fast");
            hideOffersListLoader();
            initLastOffersViewedComp();
            $("html, body").animate({ scrollTop: 0 }, 0);
          }
          let regex = "page=d+";
          if (page != 1) {
            if (generatedURL.includes(regex)) {
              generatedURL.replace(regex, `page=${page}`);
            } else if (generatedURL.includes("?")) {
              generatedURL += `&page=${page}`;
            } else {
              generatedURL += `?page=${page}`;
            }
          } else {
            if (generatedURL.includes(regex)) {
              generatedURL.replace(regex, "");
            }
          }
          window.history.pushState({}, document.title, generatedURL);
        })
        .catch((error) => {
          hideOffersListLoader();
          catchError(error);
        });
    }
  );

  // Filters collapse
  $(document).on('click', '.eui-cursor-pointer.psf-filter-collapsible', (event) => {
    const target = event.currentTarget;
    target.classList.toggle("opened");
    target
      .getElementsByClassName("psf-ico--chevron-up")[0]
      .classList.toggle("eui-d-none");
    target
      .getElementsByClassName("psf-ico--chevron-down")[0]
      .classList.toggle("eui-d-none");
  });
});
